class UserActionRequiredException extends Error {
  constructor(message = 'User Action Required', code = 'USER_ACTION_REQUIRED', properties) {
    super(message);
    Error.captureStackTrace(this, UserActionRequiredException);
    this.code = code;
    this.status = 400;
    this.properties = properties;
    this.userActionRequired = true;
  }
}

module.exports = UserActionRequiredException;
